const EN = {
    title: 'Users',
    table: {
        title: 'User list',
        columns: {
            id: 'ID',
            fullname: 'Full name',
            created: 'Created',
            document: 'INE',
            email: 'Email',
            role: 'Role',
            status: 'Status',
            actions: 'Actions'
        },
        status: {
            1: 'Pending',
            2: 'Active',
            3: 'Recover',
            4: 'Blocked',
            5: 'Inactive',
            'admin.natura': 'Admin',
            'operator.natura': 'Operator',
            'ext-support-operator.natura': 'External Operator',
            'fraud_prevention_analyst.natura': 'Fraud prevention operator',
            'fraud_prevention_admin.natura': 'Fraud prevention admin',
            'user_admin.natura': 'User Admin',
            'customer.natura': 'Customer',
            9: 'Information',
            10: 'Information',
            11: 'In Revision'
        },
        documentTypes: {
            dni: 'INE',
            cpf: 'CPF',
            ci_paraguay: 'CI Paraguay',
        },
        filter: {
            0: {
                title: 'Status',
                0: 'Pending',
                1: 'Active',
                2: 'Recover',
                3: 'Blocked',
                4: 'Inactive',
            },
            1: {
                title: 'Role',
                0: 'Admin',
                1: 'Operator',
                2: 'External Operator',
            }
        },
        menu: {
            add: {
                title: 'Add user',
                inputs: {
                    documentType: {
                        label: 'Type',
                        error: 'Must select a document type'
                    },
                    document: {
                        label: 'INE',
                        placeholder: 'Enter INE',
                        error: 'Please enter a valid {{type}}.'
                    },
                    name: {
                        label: 'Name',
                        placeholder: 'Enter name',
                        error: 'Must have a name'
                    },
                    surname: {
                        label: 'Surname',
                        placeholder: 'Enter surname',
                        error: 'Must have a surname'
                    },
                    email: {
                        label: 'Email',
                        placeholder: 'Enter email',
                        error: 'Must have a valid email'
                    },
                    role: {
                        label: 'Role',
                        placeholder: 'Select a role',
                        error: 'Must have a role selected'
                    }
                },
                submit: 'Apply',
                success: 'The user has been created successfully'
            },
            edit: {
                title: 'Edit user',
                inputs: {
                    fullname: {
                        label: 'Full name',
                        placeholder: 'Edit full name...',
                        error: 'Please enter a full name.'
                    },
                    email: {
                        label: 'Email',
                        placeholder: 'Edit email...',
                        error: 'You must enter a valid email to continue.'
                    },
                    role: {
                        label: 'Roles',
                        placeholder: 'Select a role',
                        error: 'Must have a role selected.'
                    }
                },
                success: 'The user has been edited successfully.',
                alerts: {
                    emailSuccess: {
                        title: 'An email has been sent to {{email}}.',
                        description: 'The client has 24 hours to access and verify the email address.'
                    },
                    emailError: {
                        title: 'The email {{email}}',
                        description: 'is not available for this client.\nPlease request another email.'
                    },
                    roleSuccess: 'The user {{fullname}} has been successfully updated.'
                }
            },
            unsubscribe: {
                title: 'Unsubscribe user',
                modal: {
                    title: 'Do you wish to unsubscribe the user',
                    date: 'Date',
                    success: 'The user unsubscription has been successfully processed'
                }
            },

        }
    }
};

export default EN;
